import config from '~/constants/config';

import IosImgMethod1Step1 from '../img/locationGuides/ios/method1/step1.jpg';
import IosImgMethod1Step2 from '../img/locationGuides/ios/method1/step2.jpg';
import IosImgMethod1Step3 from '../img/locationGuides/ios/method1/step3.jpg';
import IosImgMethod1Step4 from '../img/locationGuides/ios/method1/step4.jpg';
import IosImgMethod2Step1 from '../img/locationGuides/ios/method2/step1.jpg';
import IosImgMethod2Step2 from '../img/locationGuides/ios/method2/step2.jpg';
import IosImgMethod2Step3 from '../img/locationGuides/ios/method2/step3.jpg';
import IosImgMethod2Step4 from '../img/locationGuides/ios/method2/step4.jpg';
import IosImgMethod3Step1 from '../img/locationGuides/ios/method3/step1.jpg';
import IosImgMethod3Step2 from '../img/locationGuides/ios/method3/step2.jpg';
import IosImgMethod3Step3 from '../img/locationGuides/ios/method3/step3.jpg';
import SamsungImgStep1 from '../img/locationGuides/samsung/step1.jpg';
import SamsungImgStep2 from '../img/locationGuides/samsung/step2.jpg';
import SamsungImgStep3 from '../img/locationGuides/samsung/step3.jpg';
import SamsungImgStep4 from '../img/locationGuides/samsung/step4.jpg';
import SamsungImgStep5 from '../img/locationGuides/samsung/step5.jpg';
import SamsungImgStep6 from '../img/locationGuides/samsung/step6.jpg';
import XiaomiImgStep1 from '../img/locationGuides/xiaomi/step1.jpg';
import XiaomiImgStep2 from '../img/locationGuides/xiaomi/step2.jpg';
import XiaomiImgStep3 from '../img/locationGuides/xiaomi/step3.jpg';
import XiaomiImgStep4 from '../img/locationGuides/xiaomi/step4.jpg';
import AndroidImgStep1 from '../img/locationGuides/android/step1.jpg';
import AndroidImgStep2 from '../img/locationGuides/android/step2.jpg';
import AndroidImgStep3 from '../img/locationGuides/android/step3.jpg';
import AndroidImgStep4 from '../img/locationGuides/android/step4.jpg';

export const iosImagesMethod1 = [
  IosImgMethod1Step1,
  IosImgMethod1Step2,
  IosImgMethod1Step3,
  IosImgMethod1Step4,
];
export const iosImagesMethod2 = [
  IosImgMethod2Step1,
  IosImgMethod2Step2,
  IosImgMethod2Step3,
  IosImgMethod2Step4,
];
export const iosImagesMethod3 = [IosImgMethod3Step1, IosImgMethod3Step2, IosImgMethod3Step3];
export const xiaomiImages = [XiaomiImgStep1, XiaomiImgStep2, XiaomiImgStep3, XiaomiImgStep4];
export const samsungImages = [
  SamsungImgStep1,
  SamsungImgStep2,
  SamsungImgStep3,
  SamsungImgStep4,
  SamsungImgStep5,
  SamsungImgStep6,
];
export const androidImages = [AndroidImgStep1, AndroidImgStep2, AndroidImgStep3, AndroidImgStep4];

export const iosStepDescriptionMethod1 = (styles: string): React.ReactNode[] => [
  <div className={styles}>
    Tap the <span className="semibold">aA</span> button on the top left part of your screen
  </div>,
  <div className={styles}>
    Choose <span className="semibold">Website Settings</span>
  </div>,
  <div className={styles}>
    Choose <span className="semibold">Location</span>
  </div>,
  <div className={styles}>
    Make sure that all your permissions for m.{config.app.domainName} are set to{' '}
    <span className="semibold">Allow</span>
  </div>,
];

export const iosStepDescriptionMethod2 = (styles: string): React.ReactNode[] => [
  <div className={styles}>
    Go to you phone <span className="semibold">Settings</span> and tap on{' '}
    <span className="semibold">Privacy</span>
  </div>,
  <div className={styles}>
    Once you’re inside <span className="semibold">Privacy</span>, tap on the{' '}
    <span className="semibold">Location Services</span>
  </div>,
  <div className={styles}>
    On the <span className="semibold">Location Services</span>, choose{' '}
    <span className="semibold">Safari Websites</span>
  </div>,
  <div className={styles}>
    On the <span className="semibold">Safari Websites</span>, the While Using the App should be
    checked
  </div>,
];

export const iosStepDescriptionMethod3 = (styles: string): React.ReactNode[] => [
  <div className={styles}>
    Go to you phone <span className="semibold">Settings</span> and tap on{' '}
    <span className="semibold">Safari</span>
  </div>,
  <div className={styles}>
    Once you’re inside <span className="semibold">Safari</span>, tap on the{' '}
    <span className="semibold">Location</span>
  </div>,
  <div className={styles}>
    On the <span className="semibold">Location</span>, choose{' '}
    <span className="semibold">Allow</span>
  </div>,
];

export const samsungStepDescription = (styles: string): React.ReactNode[] => [
  <div className={styles}>
    Go to you phone <span className="semibold">Settings</span> and tap on{' '}
    <span className="semibold">Location</span>
  </div>,
  <div className={styles}>
    Once you’re inside <span className="semibold">Location</span>, tap on the{' '}
    <span className="semibold">See all</span>
  </div>,
  <div className={styles}>
    Tap on the <span className="semibold">Samsung Internet</span> or whichever browser you’re using
  </div>,
  <div className={styles}>
    Once you’re inside the App Info, tap on the <span className="semibold">Permissions</span>
  </div>,
  <div className={styles}>
    On the App Permissions, tap on the <span className="semibold">Location</span>
  </div>,
  <div className={styles}>
    On the Location Permission, make sure that the{' '}
    <span className="semibold">Allow only while using the app</span> is selected
  </div>,
];

export const xiaomiStepDescription = (styles: string): React.ReactNode[] => [
  <div className={styles}>
    Go to you phone <span className="semibold">Settings</span> and select{' '}
    <span className="semibold">Permissions</span>
  </div>,
  <div className={styles}>
    Once you’re inside <span className="semibold">Permissions</span>, find and select{' '}
    <span className="semibold">Permissions</span>
  </div>,
  <div className={styles}>
    Once you’re inside <span className="semibold">App Permissions</span>, find and select{' '}
    <span className="semibold">Location</span>
  </div>,
  <div className={styles}>
    Once you’re inside <span className="semibold">Location</span>, tap on the{' '}
    <span className="semibold">Radio Button</span> and make sure it’s{' '}
    <span className="semibold">turned on</span>
  </div>,
];

export const androidStepDescription = (styles: string): React.ReactNode[] => [
  <div className={styles}>
    Go to your phone <span className="semibold">Settings</span> and tap on{' '}
    <span className="semibold">Apps</span>
  </div>,
  <div className={styles}>
    Once you’re inside <span className="semibold">Apps</span>, choose{' '}
    <span className="semibold">Permissions</span>
  </div>,
  <div className={styles}>
    On the <span className="semibold">App Permissions</span>, choose{' '}
    <span className="semibold">Location</span>
  </div>,
  <div className={styles}>Find the browser that you’re using and switch on permissions</div>,
];
